import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ThemedIcon from '../common/ThemedIcon';
import calendarIcon from '../../images/common/calendar-icon-purple.svg';
import { getEtaDisplay } from '../../utils/claimEta';

const EtaContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 12px;
  background: var(--light, #f5f4ff);
`;

const IconTile = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #ffffff;
`;

const EtaText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const EtaValue = styled.p`
  color: var(--primary-button, #714fff);
`;

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--primary-button, #714fff);

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }
`;

/**
 * The small "In progress" marker above the label of the stage the claim is
 * currently sitting on, so the active card reads as live work rather than a
 * finished step.
 */
export const ClaimStagePill = ({ label, className }) => (
  <Pill className={`text-caption-l font-medium ${className || ''}`}>
    {label}
  </Pill>
);

ClaimStagePill.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

ClaimStagePill.defaultProps = {
  label: 'In progress',
};

const ClaimEtaRow = ({ statusItem, className }) => {
  const display = getEtaDisplay(statusItem);
  if (!display) return null;

  return (
    <EtaContainer className={className}>
      <IconTile>
        <ThemedIcon src={calendarIcon} alt="" width="18px" height="18px" />
      </IconTile>
      <EtaText>
        <p className="text-caption-l font-regular text-txtsecondary">
          {display.label}
        </p>
        <EtaValue className="text-title-m font-semibold">
          {display.value}
        </EtaValue>
      </EtaText>
    </EtaContainer>
  );
};

ClaimEtaRow.propTypes = {
  statusItem: PropTypes.shape({
    expectedVerificationDate: PropTypes.string,
    expectedDateSentToInsurer: PropTypes.string,
    expectedClaimSettlementDate: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default ClaimEtaRow;
